import { EntryMapper } from '../../../entry/infrastructure/mapper/entry.mapper';
import { PaymentMapper } from '../../../payment/domain/mappers/payment.mapper';
import { Account } from '../../domain/model/account.model';
import { IApiAccount } from '../../../../../shared/infrastructure/dto/account-api.interface';
import { IAccount } from '../interfaces/account-storage.interface';
import { AccountApiMapper } from './account-api.mapper';

export class AccountStorageMapper {
  static fromApi(apiAccount: IApiAccount): IAccount {
    return AccountApiMapper.fromApi(apiAccount);
  }

  static fromEntity(account: Account): IAccount {
    return {
      _id: account?.id,
      negocio_id: account.negocio_id,
      closed: account.closed,
      waiter_id: account.waiterId,
      device_id: account.device_id,
      cash_drawer_id: account.cashDrawerId,
      products_quantity: account.productsQuantity,
      total: account.total,
      totalAmount: account.total,
      service_id: account.service_id,
      location_id: account.locationId,
      payments_ids: account.paymentIds,
      refund_ids: account.refund_ids,
      zona_id: account.zona_id,
      created_at: account.createdAt,
      created_by: account.created_by,
      updated_at: account.updated_at,
      removed_at: account.removed_at,
      closed_at: account.closedAt,
      note: account.note,
      name: account.name,
      booking_id: account.bookingId,
      entries: account.entries?.map(EntryMapper.toStorage) ?? [],
      trackId: account.trackId,
      formatedDate: account.formatedDate,
      formatedHour: account.formatedHour,
      closedFormatedHour: account.closedFormatedHour,
      ticket_id: account.ticket_id,
      serie: account.serie,
      ticketNumber: account.ticketNumber,
      ticketSerie: account.ticketSerie,
      ticketPrefix: account.ticketPrefix,
      payments: account.payments.map(PaymentMapper.toStorage),
      totalPaid: account.totalPaid,
      totalRemaining: account.totalRemaining,
      priceCurrency: account.priceCurrency,
      color: account.color,
      location: account.location,
      drawer: account.drawer,
      waiter: account.waiter,
      serverUpdatedAt: account.serverUpdatedAt,
      actualUpdatedAt: account.actualUpdatedAt,
      isLocked: account.isLocked,
    };
  }
}
